import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import LaptopImg from "../../assets/home-main.svg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiOutlineTwitter } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import homeProfile from "../../assets/home-profile.jpg";

const About = () => {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <p className="home-about-body">
              Innovative React and Node JS Developer with over 3 years of
              experience creating dynamic and responsive web applications from
              scratch to end.
              <br />
              <br />
              Possessing a strong foundation in{" "}
              <b className="yellow">
                {" "}
                React.js, Node.js, Express.js, Redux, HTML, CSS, SASS,
                JavaScript, TypeScript, MongoDB, Firebase, Git, GitHub and
                GitLab.
              </b>
              <br />
              <br />
              Throughout my career, I have collaborated with talented teams to
              successfully deliver high-quality projects. I excel in agile
              development methodologies and possess strong problem-solving
              skills, allowing me to identify and rectify issues swiftly. My
              commitment to continuous learning ensures I stay up-to-date with
              latest industry trends and technologies, leveraging cutting-edge
              tools and frameworks like Nest.js to enhance the development
              process and deliver optimal solutions.
              <br />
              <br />
              If you're seeking a dedicated<b className="yellow"> React </b>and
              <b className="yellow"> Node JS </b>developer who can contribute to
              your team's success, I invite you to connect with me. Let's
              explore opportunities together to collaborate and create efficient
              web applications that suited to user needs.
              {/* Additionally, I have a firm grasp of{" "}
              <b className="yellow"> Node JS, </b>, enhancing my ability to
              collaborate effectively across the MERN stack.
              <br />
              <br />
              Passionate about learning new technologies, bringing ideas to
              life, and dedicated to working with teams to build efficient web
              applications suited to user needs. */}
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            {/* <Tilt> */}
            <img src={LaptopImg} className="img-fluid" alt="avatar" />
            {/* </Tilt> */}
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>Please don't hesitate to reach out to me and connect.</p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/fahadsharif281"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  aria-label="github"
                >
                  <AiFillGithub />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/faha
                  d-sharif-a9922820b"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  aria-label="linkedin"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
        <div>
          <img src={homeProfile} className="profile_img" />
        </div>
      </Container>
    </Container>
  );
};

export default About;
